import React, { useEffect, useState, useRef } from 'react';
import {withTranslation} from 'react-i18next';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es-mx';
import { Grid, Col, ControlLabel, Button, Panel, Dropdown, Icon, DatePicker, IntlProvider } from 'rsuite';
import esES from 'rsuite/lib/IntlProvider/locales/es_ES';
import enUS from 'rsuite/lib/IntlProvider/locales/en_US';
import dateFnsFormat from 'date-fns/format';
import dateFnsEsLocale from 'date-fns/locale/es';
import Layout from '../../../components/Layout';
import TableList from '../../../components/TableList';
import $ from 'jquery';
import ModalLocationMap from '../ModalLocationMap';
import ModalChecks from './ModalChecks';

const TrackingChecks = (props)=>{
    const { t, i18n } = useTranslation("translations");
    var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
    accountId = accountId.substring(1, accountId.length - 1);
    const [start_date, setStartDate] = useState('');
    const [end_date, setEndDate] = useState('');
    const [columns, setColumns] = useState([
        {title:'employee', name:'employee', visible:true, width:'25%'},
        {title:'start_date', name:'start_date', visible:true, width:'15%'},
        {title:'start_location', name:'start_location', visible:true, width:'10%'},
        {title:'end_date', name:'end_date', visible:true, width:'15%'},
        {title:'end_location', name:'end_location', visible:true, width:'10%'},
        {title:'visit_time', name:'visit_time', visible:true, width:'10%'},
        {title:'route', name:'route', visible:true, width:'15%'}
    ]);
    const [list, setList] = useState([]);
    const [listRoute, setListRoutes] = useState([]);

    const table_ref = useRef(null);
    const modal_check_ref = useRef(null);

    const [showModalLocation, setShowModalLocation] = useState(false);
    const [showModalChecks, setShowModalChecks] = useState(false);
    const [currentLat, setCurrentLat] = useState('');
    const [currentLng, setCurrentLng] = useState('')
    const [currentName, setCurrentName] = useState('')
    const [currentItem, setCurrentItem] = useState('')
    // No es solo un guard de "cargando" — Navigation.js's componentDidMount
    // (hermano de este componente dentro de Layout) llama a change(), que si
    // encuentra un elemento .table en el DOM intenta llegar al ref de
    // TableList vía _owner.stateNode.table (un hack de fibra interna de
    // React pensado para screens de clase con this.table). En un componente
    // de función stateNode es null, así que si <TableList> ya estuviera
    // montado en el primer render, esto revienta con "Cannot read
    // properties of undefined (reading 'stateNode')" apenas se entra a la
    // pantalla. Montar <TableList> recién en un efecto (un commit después
    // del montaje inicial, ya con Navigation resuelto) evita la carrera.
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        // Mismo idioma para moment que el resto de los reportes — moment usa
        // su propio locale global, independiente del de i18next.
        moment.locale(i18n.language && i18n.language.startsWith('en') ? 'en' : 'es-mx');
        setShowTable(true);
        StarLoad();
    }, []);

    const StarLoad = async() => {
        if(props.location.state !== undefined){
            var dates = {
                start: props.location.state.startDate,
                end: props.location.state.endDate
            };
            setStartDate(dates.start);
            setEndDate(dates.end);
            await search(dates, null, 'reports/route-checks');
        }else{
            let date = new Date();
            let mont = (date.getMonth()+1) < 10 ? '0'+ (date.getMonth()+1) : (date.getMonth()+1);
            let day = date.getDate() < 10 ? '0'+ date.getDate() : date.getDate();
            let dates = {
                start:date.getFullYear()+'-'+mont+'-'+'01',
                end:date.getFullYear()+'-'+mont+'-'+day
            }
            setStartDate(dates.start);
            setEndDate(dates.end);
            await search(dates, null, 'reports/route-checks');
        }
    }

    // El DatePicker de rsuite entrega un objeto Date (o null si se limpia),
    // no un string como el <input type="date"> nativo que reemplaza — el
    // resto del componente (search(), el estado) sigue esperando 'YYYY-MM-DD'.
    const handleDateChange = (setter, date) => {
        if(date){
            setter(moment(date).format('YYYY-MM-DD'));
        }
    }

    const search = async (dates, e, url) => {
        $('.rs-btn-default').blur();

        var obj = {
            startDate: dates? dates.start : start_date,
            endDate: dates? dates.end : end_date
        };

        var req = {
            api: 'reports',
            url: url+'/'+accountId,
            obj: obj,
            method: 'POST',
            modal: props.modal_loader,
            message_modal: t('modal.spin.searching'),
            requireToken: true
        };

        var request = await props.fetchRequest(req);

        if (request) {
            var list = [];

            request.map((l)=>
                list.push([
                    l.employeeName? l.employeeName:'',
                    moment(l.startDate).format('DD/MM/YYYY HH:mm'),
                    l.startLocation !== null ?
                        'icon/map-marker/green/start_location/one/'+l.startLocation.latitude+'/'+l.startLocation.longitude
                        : 'icon/map-marker/#7E7E7E/no_location/no_action/0/0',
                    moment(l.endDate).format('DD/MM/YYYY HH:mm'),
                    l.endLocation !== null ?
                        'icon/map-marker/green/end_location/one/'+l.endLocation.latitude+'/'+l.endLocation.longitude
                        : 'icon/map-marker/#7E7E7E/no_location/no_action/0/0',
                    l.routeTime !== null ? l.routeTime : '',
                    "icon/map/"+ '#2196F3' +"/route/"+'one'
                ])
            );

            setList(list);
            setListRoutes(request);

            // Mismo defer de 1 tick que Entries/CheckInFace/Visit/Overtime:
            // esta tabla usa scrollX + fixedColumns, y esa extensión termina
            // su propio armado en un callback diferido después del primer
            // pintado — destruir/reinicializar antes de que corra revienta
            // con "Failed to execute 'removeChild'". Se corre siempre (no
            // solo en la carga inicial): antes, un segundo "Buscar" nunca
            // refrescaba la tabla en pantalla porque resetTable()/setTable()
            // solo se llamaban en la carga automática inicial.
            setTimeout(()=>{
                if(table_ref.current){
                    table_ref.current.resetTable();
                    table_ref.current.setTable();
                }
            }, 0);
        }
    }

    const actionIcon = async (e, i, d) => {
        if(d === 'route'){
            OpenModalChecks(listRoute[i])
        }else{
            OpenModalMap(listRoute[i], d)
        }
    }

    const updateColumns = (e, i) => {
        var updated = [...columns];
        updated[i] = {...updated[i], visible: e.target.checked};
        setColumns(updated);
    }

    const OpenModalMap = (item, d) => {
        let lat = '', lng = '';
        if (d === 'start_location') {
            lat = item.startLocation.latitude;
            lng = item.startLocation.longitude;
        }
        if (d === 'end_location') {
            lat = item.endLocation.latitude;
            lng = item.endLocation.longitude;
        }

		setCurrentLat(lat);
		setCurrentLng(lng);
		setCurrentName(item.employeeName)
		setShowModalLocation(true);
	}

	const CloseModalMap = () => {
		setCurrentLat('');
		setCurrentLng('');
		setCurrentName('')
		setShowModalLocation(false);
	}

    const OpenModalChecks = (item) => {
        setCurrentItem(item);
        setShowModalChecks(true);
    }

    const CloseModalChecks = () => {
        setCurrentItem('');
        setShowModalChecks(false);
    }

    // El DatePicker de rsuite trae su propio calendario/textos ("Today",
    // días/meses) en inglés por defecto — IntlProvider lo traduce al idioma
    // actual de la app (i18next). Además, el mes del header del calendario
    // lo formatea rsuite con date-fns (no con moment, a pesar de usar tokens
    // estilo moment), así que necesita su propio formatDate aparte.
    const isEnglish = i18n.language && i18n.language.startsWith('en');
    const rsuiteLocale = isEnglish ? enUS : esES;
    const formatDate = (date, formatStr) => isEnglish ?
        dateFnsFormat(date, formatStr)
        : dateFnsFormat(date, formatStr, {locale: dateFnsEsLocale});

    return (
        <IntlProvider locale={rsuiteLocale} formatDate={formatDate}>
        <Layout {...props}>
            <Grid fluid>
                <Col xs={24}>
                    <h3 className="s-title-page">{t('screen.reports.tracking.name')}</h3>
                </Col>
                <Col xs={24}>
                <Panel className="panel-general" shaded>
                    <Col xs={24} sm={4}>
                        <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.start_date')}</ControlLabel>
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={start_date ? moment(start_date).toDate() : null}
                            onChange={(date)=>handleDateChange(setStartDate, date)}
                            cleanable={false}
                            oneTap
                            style={{width:'100%'}}
                            size="sm"
                        />
                    </Col>

                    <Col xs={24} sm={4}>
                        <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.end_date')}</ControlLabel>
                        <DatePicker
                            format="DD/MM/YYYY"
                            value={end_date ? moment(end_date).toDate() : null}
                            onChange={(date)=>handleDateChange(setEndDate, date)}
                            cleanable={false}
                            oneTap
                            style={{width:'100%'}}
                            size="sm"
                        />
                    </Col>

                    <Col xs={24} sm={6} style={{marginTop:30}}>
                        <Button className="s-btn-primary" onClick={(e)=>search(null, e, 'reports/route-checks')}>
                            {t('button.search')}
                        </Button>
                        <Button onClick={(e)=>props.history.goBack()} style={{marginLeft:8}}>
                            {t('button.return')}
                        </Button>
                    </Col>
                    <Col xs={24} sm={10} style={{marginTop:30, textAlign:'right', whiteSpace:'nowrap'}}>
                        <Dropdown title={t('general.table.export')} placement="bottomEnd" className="export-dropdown" style={{display:'inline-block'}}>
                            <Dropdown.Item disabled={list.length === 0} onClick={()=> list.length > 0 && table_ref.current && table_ref.current.triggerButton('buttons-excel')}>Excel</Dropdown.Item>
                            <Dropdown.Item disabled={list.length === 0} onClick={()=> list.length > 0 && table_ref.current && table_ref.current.triggerButton('buttons-pdf')}>PDF</Dropdown.Item>
                        </Dropdown>
                        <Dropdown
                            title={<><Icon icon="columns" /> {t('general.table.columns')}</>}
                            placement="bottomEnd"
                            className="columns-dropdown"
                            style={{marginLeft:8, display:'inline-block'}}
                        >
                            {columns.map((c, i)=>(
                                <Dropdown.Item key={i}>
                                    <label className="col-visibility-item" onClick={(e)=>e.stopPropagation()}>
                                        <input
                                            type="checkbox"
                                            checked={c.visible}
                                            onChange={(e)=>updateColumns(e, i)}
                                        /> {t('screen.reports.tracking.columns.'+c.name)}
                                    </label>
                                </Dropdown.Item>
                            ))}
                        </Dropdown>
                    </Col>
                    <Col xs={24}>
                        {showTable &&
                            <TableList
                                t={t}
                                onRef={ref => table_ref.current = ref}
                                columns={columns}
                                btnNew={false}
                                data={list}
                                actions={[]}
                                actionIcon={actionIcon}
                                screen={"tracking"}
                                searching={false}
                                report={true}
                                table_title={[]}
                                filename={t('screen.reports.tracking.name')}
                                scroll={true}
                                scrollY="calc(100vh - 280px)"
                                widths={columns.map(c => c.width)}
                                search={search}
                            />
                        }
                    </Col>
                </Panel>
                </Col>
            </Grid>

            {showModalLocation &&
                <ModalLocationMap
                    open={showModalLocation}
                    close={CloseModalMap}
                    lat={currentLat}
                    lng={currentLng}
                    name={currentName}
                />
            }

            {showModalChecks &&
                <ModalChecks
                    open={showModalChecks}
                    close={CloseModalChecks}
                    item={currentItem}
                    ref={modal_check_ref}
                    fetchRequest={props.fetchRequest}
                    modal_loader={props.modal_loader}
                    t={t}
                />
            }
        </Layout>
        </IntlProvider>
    )

}

export default withTranslation('translations')(TrackingChecks);
